var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMw = function SvgMw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12c0 1.468.264 2.874.746 4.174L12 16.695l11.254-.521c.482-1.3.746-2.706.746-4.174 0-1.468-.264-2.874-.746-4.174L12 7.304.746 7.826A11.975 11.975 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 0C6.84 0 2.442 3.256.746 7.826h22.507C21.558 3.256 17.16 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M23.253 16.175H.746C2.442 20.745 6.84 24 12 24c5.16 0 9.558-3.257 11.253-7.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m15.586 5.74-1.465-.69.78-1.419-1.591.305-.202-1.608L12 3.51 10.89 2.328l-.201 1.608-1.592-.305.78 1.42-1.465.689h7.173Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMw;